import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Form, Input, message, Tooltip } from "antd";
import {
  saveImportedUsers,
  getAllUsers,
  deleteUserByEmail,
  emptyImportErrors,
} from "../../actions/users";
import Modal from "antd/lib/modal/Modal";
import WizardExcelImport from "./wizardExcelImport";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { withTranslation } from "react-i18next";
import WizardDownloadTemplate from "./wizardDownloadTemplate";

const mapDispatchToProps = (dispatch) => {
  return {
    saveImportedUsers: (saveObject) => dispatch(saveImportedUsers(saveObject)),
    getAllUsers: (groupIds, companyId) =>
      dispatch(getAllUsers(groupIds, companyId)),
    deleteUserByEmail: (email) => dispatch(deleteUserByEmail(email)),
    emptyImportErrors: () => dispatch(emptyImportErrors()),
  };
};

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 20,
    },
  },
};

class ConnectedWizardImportProxy extends Component {
  state = {
    file: [],
    users: [],
    newUsers: [],
    lastName: "",
    firstName: "",
    email: "",
    proxy: "",
    proxyCards: [],
    newProxyCards: [],
    position: "",
    phoneNumber: "",
    modify: false,
    modifyIndex: null,
    excelImportVisible: false,
    errorsVisible: false,
    errors: 0,
    downloadTemplateVisible: false,
  };

  formRef = React.createRef();

  componentDidMount = async () => {
    await this.getUsers();
    let errorNumber = 0;
    if (this.props.importErrors) {
      if (this.props.importErrors.duplicatedInSystem[0]) {
        errorNumber =
          errorNumber + this.props.importErrors.duplicatedInSystem.length;
      }
      if (this.props.importErrors.emptyEmail[0]) {
        errorNumber = errorNumber + this.props.importErrors.emptyEmail.length;
      }
      if (this.props.importErrors.emptyProxy[0]) {
        errorNumber = errorNumber + this.props.importErrors.emptyProxy.length;
      }
      if (this.props.importErrors.badEmail[0]) {
        errorNumber = errorNumber + this.props.importErrors.badEmail.length;
      }
    }
    this.setState({ errors: errorNumber });
  };

  getUsers = async () => {
    await this.props.getAllUsers([2, 3, 4, 5], this.props.user.companyId);
    if (this.props.status) {
      this.setState({ proxyCards: this.props.users });
    }
  };

  removeFile = () => {
    this.setState({ file: [] });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  checkIfEmailExistsInUsers = (email) => {
    if (
      this.state.proxyCards.filter((user) => user.email === email).length > 1
    ) {
      return true;
    } else {
      return false;
    }
  };

  handleSubmit = () => {
    const userToAdd = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      position: this.state.position,
      phoneNumber: this.state.phoneNumber,
    };
    if (this.checkIfEmailExistsInUsers(userToAdd.email)) {
      message.error(
        `${this.props.t("wizard-excel-import-emailexists")} ${
          this.state.email
        }`,
        2
      );
      return;
    }
    if (this.state.modify) {
      let proxyCards = this.state.proxyCards;
      let newProxyCards = this.state.newProxyCards;
      proxyCards[this.state.modifyIndex] = userToAdd;
      newProxyCards[this.state.modifyIndex - this.props.users.length] =
        userToAdd;
      this.setState({
        firstName: "",
        lastName: "",
        email: "",
        position: "",
        phoneNumber: "",
        proxyCards: [...proxyCards],
        modify: false,
        modifyIndex: null,
      });
    } else {
      if (
        (this.props.user.company.subscription.maxUser === null
          ? Number.MAX_SAFE_INTEGER
          : this.props.user.company.subscription.maxUser) >=
        this.state.proxyCards.length
      ) {
        this.setState({
          firstName: "",
          lastName: "",
          email: "",
          position: "",
          phoneNumber: "",
          proxyCards: [...this.state.proxyCards, userToAdd],
          newProxyCards: [...this.state.newProxyCards, userToAdd],
        });
      } else {
        message.error(this.props.t("wizard-excel-maxuser-error"));
      }
    }
    this.formRef.current.resetFields();
  };

  saveUsers = async () => {
    const saveObj = {
      proxyCards: this.state.proxyCards,
      companyId: this.props.user.companyId,
    };
    if (this.state.proxyCards.length === 0) {
      this.props.next();
    } else {
      await this.props.saveImportedUsers(saveObj);
      this.props.emptyImportErrors();
      if (this.props.saveStatus) {
        this.props.next();
      } else {
        if (this.props.message?.code && this.props.message.code === 1003) {
          message.error(
            `${this.props.t("wizard-excel-import-emailexists")} ${
              this.props.message.data.email
            }!`,
            2
          );
        } else {
          message.error("Hiba a felhasználók mentése során!", 5);
        }
      }
    }
  };

  handleDeleteFromImported = async (record) => {
    const filtered = this.state.proxyCards.filter(
      (user) => user.email !== record.email
    );
    await this.props.deleteUserByEmail(record.email);
    this.setState({ proxyCards: filtered });
  };

  cancelModify = () => {
    this.setState({ modify: false, modifyIndex: null });
    this.formRef.current.resetFields();
  };

  handleModifyImportedUser = (record, index) => {
    this.setState({
      modify: true,
      email: record.email,
      firstName: record.firstName,
      lastName: record.lastName,
      position: record.position,
      phoneNumber: record.phoneNumber,
      modifyIndex: index,
    });
    this.formRef.current.setFieldsValue({
      email: record.email,
      firstName: record.firstName,
      lastName: record.lastName,
      position: record.position,
      phoneNumber: record.phoneNumber,
    });
  };

  handleClickAddUser = async () => {
    await this.formRef.current.validateFields();
    const errors = this.formRef.current.getFieldsError();
    if (
      !errors.filter((error) => {
        return error.errors.length !== 0;
      })[0]
    ) {
      this.handleSubmit();
    }
  };

  openDownloadTemplate = () => {
    this.setState({ downloadTemplateVisible: true });
  };

  closeDownloadTemplate = () => {
    this.setState({ downloadTemplateVisible: false });
  };

  openExcelImport = () => {
    this.setState({ excelImportVisible: true, downloadTemplateVisible: false });
  };

  closeExcelImport = async () => {
    this.setState({ excelImportVisible: false });
    await this.getUsers();
  };

  openErrors = () => {
    this.setState({ errorsVisible: true });
  };

  closeErrors = () => {
    this.setState({ errorsVisible: false });
  };

  render() {
    const columns = [
      {
        title: (
          <h3>
            <strong>{this.props.t("email-label")}</strong>
          </h3>
        ),
        key: "email",
        dataIndex: "email",
      },
      {
        title: (
          <h3>
            <strong>{this.props.t("profile-position-label")}</strong>
          </h3>
        ),
        key: "rfidString",
        dataIndex: "rfidString",
      },
    ];

    return (
      <div>
        <Row style={{ margin: "10px 0 10px 0" }}>
          <Col span={8} style={{ padding: "1em" }}>
            <Form
              onFinish={this.handleSubmit}
              ref={this.formRef}
              {...formItemLayout}
              name="design"
              scrollToFirstError
              layout="vertical"
            >
              <Form.Item
                name="email"
                label={
                  <div>
                    <strong>{this.props.t("email-label")}:</strong>&nbsp;
                    <Tooltip
                      title={this.props.t("wizard-import-email-tooltip")}
                      placement="right"
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </div>
                }
                rules={[
                  {
                    required: true,
                    message: this.props.t("email-empty"),
                  },
                  {
                    type: "email",
                    message: this.props.t("email-wrong-format"),
                  },
                ]}
              >
                <Input name="email" onChange={this.handleChange} />
              </Form.Item>

              <Form.Item
                name="rfidSting"
                label={
                  <strong>{this.props.t("profile-position-label")}:</strong>
                }
              >
                <Input name="rfidString" onChange={this.handleChange} />
              </Form.Item>

              <Form.Item style={{ textAlign: "center" }}>
                <Button
                  type="primary"
                  style={{
                    background: "#000000",
                    borderColor: "#000000",
                    margin: "1em",
                  }}
                  htmlType="submit"
                >
                  {this.props.t("add-button-label")}
                </Button>
                {this.state.modify && (
                  <Button onClick={this.cancelModify} style={{ margin: "1em" }}>
                    {this.props.t("cancel-button-label")}
                  </Button>
                )}
              </Form.Item>
              <Form.Item style={{ textAlign: "center" }}>
                <Button type="dashed" onClick={this.openDownloadTemplate}>
                  {this.props.t("wizard-import-from-excel-button")}
                </Button>
              </Form.Item>
            </Form>
          </Col>
          <Col span={16} style={{ padding: "0.5em" }}>
            <div>
              {((this.props.importErrors.duplicatedInSystem &&
                this.props.importErrors.duplicatedInSystem.length > 0) ||
                (this.props.importErrors.emptyFirstName &&
                  this.props.importErrors.emptyFirstName.length > 0) ||
                (this.props.importErrors.emptyLastName &&
                  this.props.importErrors.emptyLastName.length > 0) ||
                (this.props.importErrors.badEmail &&
                  this.props.importErrors.badEmail.length > 0) ||
                (this.props.importErrors.duplicatedEmail &&
                  this.props.importErrors.duplicatedEmail.length > 0)) && (
                <Button
                  danger
                  type="primary"
                  style={{ marginBottom: "0.4em" }}
                  onClick={this.openErrors}
                >
                  {this.props.t("import-errors-button-label")} (
                  {this.state.errors})
                </Button>
              )}
            </div>
            <Table
              dataSource={this.state.proxyCards}
              columns={columns}
              rowKey="E-mail"
              pagination={{
                total: this.state.proxyCards.length,
                pageSize: this.state.proxyCards.length,
                hideOnSinglePage: true,
              }}
              scroll={{ y: 500 }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: "center" }}>
            <div>
              {this.props.wizard && (
                <Button
                  style={{ margin: "1em" }}
                  onClick={() => this.props.prev()}
                >
                  {this.props.t("back-button-label")}
                </Button>
              )}
              <Button
                type="primary"
                onClick={this.saveUsers}
                style={{ margin: "1em" }}
              >
                {this.props.t("next-button-label")}
              </Button>
            </div>
          </Col>
        </Row>

        <Modal
          maskClosable={false}
          closable={true}
          footer={null}
          visible={this.state.excelImportVisible}
          centered
          onCancel={this.closeExcelImport}
        >
          <WizardExcelImport
            next={this.closeExcelImport}
            nextVisible={false}
            back={this.closeExcelImport}
          />
        </Modal>
        <Modal
          maskClosable={false}
          closable={true}
          footer={null}
          visible={this.state.errorsVisible}
          centered
          onCancel={this.closeErrors}
          title={this.props.t("import-errors-button-label")}
        >
          {this.props.importErrors.duplicatedEmail &&
            this.props.importErrors.duplicatedEmail[0] && (
              <div>
                <div>
                  <strong>{this.props.t("duplicate-email-infile")}</strong>
                </div>
                <div>
                  {this.props.importErrors.duplicatedEmail?.map((email) => {
                    return email.index + ". " + email.email + ", ";
                  })}
                </div>
              </div>
            )}
          {this.props.importErrors.duplicatedInSystem &&
            this.props.importErrors.duplicatedInSystem[0] && (
              <div>
                <div>
                  <strong>{this.props.t("duplicate-email-insystem")}</strong>
                </div>
                <div>
                  {this.props.importErrors.duplicatedInSystem?.map((email) => {
                    return email.email + ", ";
                  })}
                </div>
              </div>
            )}
          {this.props.importErrors.emptyFirstName &&
            this.props.importErrors.emptyFirstName[0] && (
              <div>
                <div>
                  <strong>{this.props.t("empty-firstname-label")}</strong>
                </div>
                <div>
                  {this.props.importErrors.emptyFirstName?.map((email) => {
                    return email.email + ", ";
                  })}
                </div>
              </div>
            )}
          {this.props.importErrors.emptyLastName &&
            this.props.importErrors.emptyLastName[0] && (
              <div>
                <div>
                  <strong>{this.props.t("empty-lastname-label")}</strong>
                </div>
                <div>
                  {this.props.importErrors.emptyLastName?.map((email) => {
                    return email.email + ", ";
                  })}
                </div>
              </div>
            )}
        </Modal>
        <Modal
          maskClosable={false}
          closable={true}
          footer={null}
          visible={this.state.downloadTemplateVisible}
          centered
          onCancel={this.closeDownloadTemplate}
        >
          <WizardDownloadTemplate
            next={this.openExcelImport}
            prev={this.closeDownloadTemplate}
          />
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  user: state.loginReducer.user,
  saveStatus: state.usersReducer.saveStatus,
  message: state.usersReducer.message,
  status: state.usersReducer.status,
  users: state.usersReducer.users,
  cards: state.cardReducer.cards,
  importErrors: state.usersReducer.importErrors,
});
const WizardImportProxy = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ConnectedWizardImportProxy)
);
export default WizardImportProxy;
